const randomize = require("randomatic");
export default [
  {
    id: randomize("Aa0", 32),
    component: () => import("../../shared/list-filters/HeadOfficeFilter"),
    props: {
      filterName: "head_office_id",
      label: "HeadOffice",
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../../shared/list-filters/TextFilter"),
    props: {
      filterName: "client_surname_contains",
      label: "Client Surname",
      filterValue: null,
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../../shared/list-filters/TextFilter"),
    props: {
      filterName: "service_name_contains",
      label: "Service",
      filterValue: null,
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../../shared/list-filters/TextFilter"),
    props: {
      filterName: "supplier_name_contains",
      label: "Supplier",
      filterValue: null,
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../../shared/list-filters/TextFilter"),
    props: {
      filterName: "supplier_destination_name_contains",
      label: "Supplier Destination",
      filterValue: null,
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../../shared/list-filters/TextFilter"),
    props: {
      filterName: "supplier_region_contains",
      label: "Supplier Region",
      filterValue: null,
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../../shared/list-filters/BooleanFilter"),
    props: {
      filterName: "historical",
      label: "Historical",
      filterValue: null,
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../../shared/list-filters/BooleanFilter"),
    props: {
      filterName: "custom_price_eq",
      label: "Custom Price",
      filterValue: null,
    },
  },
  /*
  {
    id: randomize("Aa0", 32),
    component: () => import("../../shared/list-filters/DestinationFilter"),
    props: {
      filterName: "destinationId",
      label: "Destination",
      filterValue: null,
    },
  },*/
  {
    id: randomize("Aa0", 32),
    component: () => import("../../shared/list-filters/DestinationMultiFilter"),
    props: {
      filterName: "destinations_eq",
      label: "Destinations",
      filterValue: null,
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../../shared/list-filters/TextFilter"),
    props: {
      filterName: "agent_name_contains",
      label: "Agent",
      filterValue: null,
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../../shared/list-filters/TextFilter"),
    props: {
      filterName: "itinerary_ref_contains",
      label: "Itinerary Ref",
      filterValue: null,
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../../shared/list-filters/ServiceStatusFilter"),
    props: {
      filterName: "serviceStatuses_eq",
      label: "Itinerary Status",
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../../shared/list-filters/TextFilter"),
    props: {
      filterName: "itinerary_internal_ref_contains",
      label: "Iti Internal Ref",
      filterValue: null,
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () =>
      import("../../shared/list-filters/InternalStatusMultiFilter"),
    props: {
      filterName: "internalStatus_eq",
      label: "Internal Status",
      filterValue: null,
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../../shared/list-filters/ItineraryStatusFilter"),
    props: {
      filterName: "itineraryStatuses_eq",
      label: "Itinerary Status",
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../../shared/list-filters/DepartmentMultiFilter"),
    props: {
      filterName: "departments_eq",
      label: "Departments",
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../../shared/list-filters/DatesRangeFilter"),
    props: {
      filterName: "date_from",
      label: "Date Between",
    },
    defaultValue: {
      date_from_gte: new Date().toISOString().split("T")[0],
      date_from_lte: new Date().toISOString().split("T")[0],
    },
    defaultLabel: `${new Date().toISOString().split("T")[0]} - ${
      new Date().toISOString().split("T")[0]
    }`,
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../../shared/list-filters/DatesRangeFilter"),
    props: {
      filterName: "creation_dates",
      label: "Iti Created Between",
    },
    defaultLabel: `${new Date().toISOString().split("T")[0]} - ${
      new Date().toISOString().split("T")[0]
    }`,
  },
  {
    id: randomize("Aa0", 32),
    component: () =>
      import("../../shared/list-filters/SupplierTypeMultiFilter"),
    props: {
      filterName: "serviceType",
      filterValue: null,
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../../shared/list-filters/BrandMultiFilter"),
    props: {
      filterName: "brands_eq",
      label: "Brands",
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../../shared/list-filters/LeadSourceMultiFilter"),
    props: {
      filterName: "leadSources_eq",
      label: "Lead Source",
      filterValue: null,
    },
  },
];



// WEBPACK FOOTER //
// ./src/components/gt/plugins/histories/filters.js